module.exports = __webpack_public_path__ + "img/otto-data@2x.e2b5a9a1.png";